export default [
    {
        path: '/generateGrids',
        name: 'generateGrids',
        component: () => import ('./pages/Index')
    },
]